import { CustomMapPage, CustomMapPageProps } from 'pages/custom/shared/CustomMapPage';

export const MartinMapWrapper = (props: CustomMapPageProps): JSX.Element => {
    return (
        <CustomMapPage
            {...props}
            mapProps={{
                ...props.mapProps
            }}
            onMapLoaded={(mapRef) => {
                props.onMapLoaded?.(mapRef);
            }}
            orderedMarkerIds={[
                '0.8973716924843724',
                '0.2557708059800943',
                '0.38460617969635047',
                '0.25107465420415886',
                '0.9365884966550273',
                '0.09417434021801396',
                //purple
                '0.31378241951484775',
                '0.22799464505294753',
                '0.29830120409457095',
                '0.12980611010511023',
                '0.7342843566245112',
                '0.42385908864211275',
                '0.07170592926799979'
            ]}
        />
    );
};
